import { Dialog } from '@radix-ui/themes';
import { action, makeObservable, observable } from 'mobx';
import { ReactNode } from 'react';

export class GlobalDialogService {
   opened = false;
   content: ReactNode = null;
   settings: Dialog.ContentProps = {};

   constructor() {
      makeObservable(this, {
         opened: observable,
         settings: observable,
         open: action,
         close: action,
      });
   }

   render(): ReactNode {
      return this.content;
   }

   open(component: ReactNode, opts: Dialog.ContentProps = {}): void {
      this.content = component;
      this.opened = true;
      this.settings = opts;
   }

   close(): void {
      this.content = null;
      this.opened = false;
      this.settings = {};
   }
}
